import moment from "moment";
import { Dimensions, Platform } from "react-native";
import {
  responsiveHeight,
  responsiveWidth,
} from "../components/customResponsiveDimension";
import loadable from "@loadable/component";

export const getTime = () => {
  var now = new Date();
  var hours = now.getHours();
  let day;
  if (hours < 12) {
    day = "Good morning";
  } else if (hours < 16) {
    day = "Good afternoon";
  } else if (hours < 24) {
    day = "Good evening";
  }
  return day;
};

export function getResponsiveStyle(styleName, measure) {
  const styleName_Width = `${styleName}_${measure}`;
  return styleName_Width;
}

export const productNavigationPrefix = (product, name, to) => {
  switch (name.trim().toLowerCase()) {
    case "Insta Save FD Account".trim().toLowerCase():
      to = "fixed_" + to;
      break;
    case "Insta Save The ONE Savings Account".trim().toLowerCase():
      to = (to === "product" ? "individual_" : "") + "the_" + to;
      break;
    default:
      break;
  }
  return to;
};



export const getRegex = (text, regex, prevValue) => {
  let isChecked;
  if (
    text === "" ||
    text === null ||
    text === undefined ||
    text === "undefined"
  ) {
    // JUST BLANK
    text = Platform.OS === "web" ? "" : text;
  } else if (!text.match(regex)) {
    isChecked = true;
  }
  return isChecked ? prevValue : text;
};

export const widthInPercentage = (dimensionWidth) => {
  if (Platform.OS === "web") {
    return `${dimensionWidth}%`;
  }
  return responsiveWidth(dimensionWidth);
};
export const heightInPercentage = (dimensionHeight) => {
  if (Platform.OS === "web") {
    return `${dimensionHeight}%`;
  }
  return responsiveHeight(dimensionHeight);
};

export const fontInPercentage = (dimensionSize) => {
  return dimensionSize;
};

export const getWidth = () => {
  const { width } = Dimensions.get("window");
  return width;
};

export const percentageOf = (width, requiredWidth) => {
  return width * (requiredWidth / 100);
};

export const getHeight = () => {
  const { height } = Dimensions.get("window");
  return height;
};

export const getAge = (birthday, format) => {
  if (birthday.length > 0) {
    return moment().diff(moment(birthday, format), "years");
  }
  return "Invalid";
};

export const getMeasure = (width) => {
  let measure = "";
  if (width < 360) {
    measure = "LDPI";
  } else if (width < 480) {
    measure = "MDPI";
  } else if (width < 640) {
    measure = "HDPI";
  } else if (width < 768) {
    measure = "XHDPI";
  } else if (width < 960) {
    measure = "XXHDPI";
  } else if (width < 1024) {
    measure = "XXXHDPI";
  } else if (width < 1440) {
    measure = "LAPTOP";
  } else if (width < 2400) {
    measure = "LAPTOP";
  }
  return measure;
};

export const capatalize = (s) => {
  if (s && typeof s === "string") {
    let resulttext = "";
    let converString = s.toLowerCase().split(" ");
    for (let i = 0; i < converString.length; i++) {
      converString[i].charAt(0).toUpperCase();
      resulttext =
        resulttext +
        (converString[i].charAt(0).toUpperCase() +
          converString[i].slice(1) +
          " ");
    }
    return resulttext.trim();
  } else {
    return s;
  }
};

export const productNames = () => [
  {
    product: "salary-account",
    path: "/salary-account/product",
    root: "/salary-account",
  },
  { product: "the-one", path: "/the-one/product", root: "/the-one" },
  {
    product: "gold-privilege",
    path: "/gold-privilege/product",
    root: "/gold-privilege",
  },
  {
    product: "savings-companion",
    path: "/savings-companion/product",
    root: "/savings-companion",
  },
  { product: "savings-fd", path: "/savings-fd/product", root: "/savings-fd" },
  {
    product: "savings-account",
    path: "/savings-account/product",
    root: "/savings-account",
  },
  { product: "travel-card", path: "/travel-card/travel", root: "/travel-card" },
  {
    product: "salary-account/infosys",
    path: "/salary-account/infosys/product",
    root: "/salary-account/infosys",
  },
  {
    product: "credit-card",
    path: "/credit-card/product",
    root: "/credit-card",
  },
  {
    product: "references",
    path: "/references",
    root: "/references",
  },
  {
    product: "osv",
    path: "/osv",
    root: "/osv",
  },
  {
    product: "gic-account",
    path: "/gic-account/gic",
    root: "/gic-account",
  },
  {
    product: "salary-account/reliance-corporate",
    path: "/salary-account/reliance-corporate/product",
    root: "/salary-account/reliance-corporate",
  },
];

export const injectUrlPaths = (location) => {
  let injectProduct = location.pathname.split("/")[1];
  let prefix = injectProduct;
  if (injectProduct.includes("-")) {
    injectProduct = injectProduct.split("-")[0];
  }

  let path = location.pathname.substring(
    location.pathname.indexOf("/") + 1,
    location.pathname.lastIndexOf("/")
  );

  if (injectProduct === "react") {
    injectProduct = "";
  } else {
    injectProduct = injectProduct + "_";
  }
  return { injectProduct, prefix, path };
};

export const browserSupport = (userAgent) => {

  return !(
    userAgent.indexOf("MSIE ") > -1 ||
    userAgent.indexOf("Trident/") > -1
  );
};

export const linearColors = () => {
  return {
    start: { x: 1, y: 0 },
    end: { x: 1, y: 1 },
    colors: ["#fff", "#fff"],
  };
};

export const otherPagecolors = () => {
  return {
    start: { x: 1, y: 0 },
    end: { x: 1, y: 1 },
    colors: ["#fff", "#fff"],
  };
};

export const fetchUrl = (windowValues, props) => {
  let url = windowValues.search.split("=");
  if (url[0] === "?lead_id") {
    let loc = windowValues.pathname.split("/");

    if (loc.length > 2) {
      props.history.push({
        pathname: "/savings-account/product",
        state: {
          token: url[1],
          product: "Travel Card ",
          navigation: "personalDetails",
          flow: true,
        },
      });
    } else {
      props.history.push({
        pathname: "/",
        state: {
          token: url[1],
          product: "Travel Card ",
          navigation: "personalDetails",
          flow: true,
        },
      });
    }
  } else if (url[0] === "?sav") {
    props.history.push({
      pathname: "/savings-account/product",
      state: {
        token: url[1],
        product: "Insta Save Account ",
        navigation: "personalDetails",
        flow: true,
      },
    });
  }
  // else if (url[0] === '?ista') {
  //   props.history.push({
  //     pathname: '/gic-account/product',
  //     state: {
  //       queryParams: getAllUrlParams(window.location.href),
  //       product:
  //         require('../Products/SavingsAccount/config').PRODUCTS['G I C'] + ' ',
  //       navigation: 'personalDetails',
  //       flow: true,
  //     },
  //   });
  // }
};

export const createSalutaion = (type) => {
  let createSalutaionArr = [
    { label: "mr", id: "1" },
    { label: "miss", id: "2" },
    { label: "dr", id: "3" },
    { label: "mrs", id: "4" },
    { label: "col", id: "5" },
    { label: "lt. col", id: "7" },
    { label: "Maj", id: "8" },
    { label: "Brig", id: "9" },
  ];
  let returnKey = "NA";
  createSalutaionArr.map((item) => {
    if (item.label === type) {
      returnKey = item.id;
    }
  });
  return returnKey;
};

export const AutoloanStateMapper = (type) => {
  let createSalutaionArr = [
    { label: "andaman and nicobar islands", id: "AN" },
    { label: "andhra pradesh", id: "AP" },
    { label: "arunachal pradesh", id: "AR" },
    { label: "assam", id: "AS" },
    { label: "bihar", id: "BR" },
    { label: "chandigarh", id: "CH" },
    { label: "chhattisgarh", id: "CT" },
    { label: "dadra and nagar haveli", id: "DN" },
    { label: "daman and diu", id: "DD" },
    { label: "delhi", id: "DL" },
    { label: "goa", id: "GA" },
    { label: "gujarat", id: "GJ" },
    { label: "haryana", id: "HR" },
    { label: "himachal pradesh", id: "HP" },
    { label: "jammu and kashmir", id: "JK" },
    { label: "jharkhand", id: "JH" },
    { label: "karnataka", id: "KA" },
    { label: "kerala", id: "KL" },
    { label: "lakshadweep", id: "LD" },
    { label: "madhya pradesh", id: "MP" },
    { label: "maharashtra", id: "MH" },
    { label: "manipur", id: "MN" },
    { label: "meghalaya", id: "ML" },
    { label: "mizoram", id: "MZ" },
    { label: "nagaland", id: "NL" },
    { label: "odisha", id: "OR" },
    { label: "puducherry", id: "PY" },
    { label: "punjab", id: "PB" },
    { label: "rajasthan", id: "RJ" },
    { label: "sikkim", id: "SK" },
    { label: "tamil nadu", id: "TN" },
    { label: "telangana", id: "TG" },
    { label: "tripura", id: "TR" },
    { label: "uttar pradesh", id: "UP" },
    { label: "uttarakhand", id: "UT" },
    { label: "west bengal", id: "WB" },
  ];
  let returnKey = "NA";
  createSalutaionArr.map((item) => {
    if (item.label === type) {
      returnKey = item.id;
    }
  });
  return returnKey;
};

export const getAllUrlParams = (url) => {
  // get query string from url (optional) or window
  let queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  const obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    const arr = queryString.split("&");

    for (let i = 0; i < arr.length; i++) {
      // separate the keys and the values
      const a = arr[i].split("=");

      // set parameter name and value (use 'true' if empty)
      const paramName = a[0];
      const paramValue = typeof a[1] === "undefined" ? true : a[1];

      // (optional) keep case consistent
      // paramName = paramName.toLowerCase();
      // if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {
        // create key if it doesn't exist
        const key = paramName.replace(/\[(\d+)?\]/, "");
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          const index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === "string") {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
};

export const getGAPathName = (path) => {
  let url = "";
  switch (path) {
    case "":
      url = "";
      break;

    case "product":
      url = "ProductDetails";
      break;

    case "personal-details":
      url = "PersonalDetails";
      break;

    case "personal-data":
      url = "PersonalData";
      break;

    case "profile":
      url = "ProfileDetails";
      break;

    case "nominee-details":
      url = "NomineeDetails";
      break;

    case "address":
      url = "Address";
      break;

    case "fd":
      url = "fd";
      break;

    case "review-confirm":
      url = "ReviewConfirm";
      break;

    case "terms-conditions":
      url = "TermsConditions";
      break;

    case "add-money":
      url = "AddMoney";
      break;

    case "transactionDetails":
      url = "transactionDetails";
      break;

    case "thankyou":
      url = "Thankyou";
      break;

    case "success":
      url = "Success";
      break;

    case "fd-success":
      url = "FDSuccess";
      break;

    case "creating-account":
      url = "CreatingAccount";
      break;

    case "choose-car":
      url = "Select_Car_Dealer";
      break;

    case "customize-loan":
      url = "Customise_Your_Loan";
      break;

    case "success":
      url = "Download_Delivery_Note";
      break;

    default:
      url = path;
  }

  return url;
};

export const navigationPrefix = () => {
  return {
    "salary-account": "individual_salary",
    "individual/the-one": "individual_the",
    "individual/gold-privilege": "individual_gold",
    "individual/savings-companion": "individual_savings",
    "individual/insta-save-fd-account": "individual_fixed",
    "individual/insta-save-account": "individual_seperate",
    "credit-card": "credit",
    "travel-card": "travel",
  };
};

export const companyDetails = () => {
  return [
    {
      name: "infosys",
      text: "for INFOSYS",
    },
    {
      name: "reliance-corporate",
      text: "for Reliance Corporate",
    },
  ];
};

export const customLoadable = (imports, options = {}) => {
  let lazyLoad = loadable(() => imports, options);
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    lazyLoad = loadable(() => imports, {
      ...options,
      ssr: false,
    });
  }
  return lazyLoad;
};

// export const enableVKYCProducts = [
//   'INSTA SAVE SALARY ACCOUNT',
//   'INSTA SAVE ACCOUNT',
//   'INSTA SAVE FD ACCOUNT',
//   'INSTA SAVE THE ONE SAVINGS ACCOUNT',
//   'INSTA SAVE GOLD PRIVILEGE SAVINGS ACCOUNT',
//   'INSTA SAVE COMPANION ACCOUNT',
//   'NRI PRO',
//   'NRI PREMIA',
//   'NRI REGULAR',
//   'SILVER CORAL CREDIT CARD',
//   'SAPPHIRO CREDIT CARD',
//   'CORAL CREDIT CARD',
//   'MUMBAI METRO CREDIT CARD',
//   'HPCL CORAL CREDIT CARD',
//   'EMERALDE CREDIT CARD',
//   'Insta Current Account Individual/Professional',
//   require('../Products/SavingsAccount/config').PRODUCTS['G I C'],
// ];

export const renameKeys = (oldObj, oldName, newName) => {
  const newObj = {};

  Object.keys(oldObj).forEach((key) => {
    const value = oldObj[key];

    if (key === oldName) {
      newObj[newName] = value;
    } else {
      newObj[key] = value;
    }
  });

  return newObj;
};

export const checkSpecialchars = (string, format = /^[^a-zA-Z]+$/) => {
  return format.test(string);
};

export const similarityCheck = (val1, val2) => {
  val1 = val1.trim().toLowerCase().split(" ");
  val2 = val2.trim().toLowerCase().split(" ");
  let isValid = true;
  let check = false;
  let arr = [];
  val1.map((item, i) => {
    let arrIn = [];
    val2.map((mitem, j) => {
      if (item !== mitem) {
        check = false;
        arrIn = [...arrIn, check];
      }
    });
    arr.push(arrIn);
  });
  arr.map((fItems) => {
    if (fItems.length === val2.length) {
      isValid = false;
    }
  });
  return isValid;
};

export const beautifyString = (
  value,
  regexStart = /^[a-zA-Z0-9].*$/im,
  regexEnd = /^.*[a-zA-Z0-9]$/im
) => {
  let mValue = value;
  for (let i = 0; i < value.length; i++) {
    if (!regexStart.test(mValue)) {
      mValue = mValue.substring(1, mValue.length);
    } else if (!regexEnd.test(mValue)) {
      mValue = mValue.substring(0, mValue.length - 1);
    }
  }
  return mValue;
};

export const checkHardwareDevice = async () => {
  let availableHardwares = [];
  let hasVideo = false;
  let hasAudio = false;
  if (process.env.NODE_ENV !== "development") {
    if (window.navigator.mediaDevices) {
      await window.navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.map((device) => {
            if (device.kind === "videoinput") {
              hasVideo = true;
            }
            if (device.kind === "audioinput") {
              hasAudio = true;
            }
            availableHardwares.push(device.kind);
          });
        })
        .catch(function (err) {});
    } else {
      console.log("No Media devices found.");
    }
  } else {
    hasVideo = true;
    hasAudio = true;
  }
  return {
    availableHardwares,
    isSupported: hasVideo && hasAudio,
    browserType: navigator.userAgent,
  };
};

export const browserSupportForVKYC = () => {
  let mUserAgent = window.navigator.userAgent.toLowerCase();
  let supportedBrowsers = ["chrome/", "safari/"];
  let isSupported = true;
  supportedBrowsers.map((item) => {
    if (mUserAgent.indexOf(item) > -1) {
      isSupported = true;
    }
  });

  return isSupported;
};

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const numberWithCommas = (num) => {
  num = num.toString().replace(",", "");
  let decimalPart = "";
  let integerPart = "";
  let finalValue;
  if (num.includes(".")) {
    integerPart = num.substring(0, num.indexOf("."));
    decimalPart = num.substring(num.indexOf(".") + 1, num.length);
  } else {
    integerPart = num;
  }

  var lastThree = integerPart.substring(integerPart.length - 3);
  var otherNumbers = integerPart.substring(0, integerPart.length - 3);
  if (otherNumbers != "") lastThree = "," + lastThree;

  integerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  if (decimalPart == "") {
    decimalPart = "00";
  }
  finalValue = integerPart.concat(`.${decimalPart}`);

  return finalValue;
};

export const formatCardNumber = (num) => {
  let formattedNum = "";
  for (let i = 1; i <= num.length; i++) {
    formattedNum = formattedNum.concat(num[i - 1]);
    if (i != 0 && i % 4 === 0) {
      formattedNum = formattedNum.concat(" ");
    }
  }
  return formattedNum;
};
/**
 * 
 * @param {string} variable 
 * @returns {string | undefined}  
 */
 export function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (const element of vars) {
    let pair = element.split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return undefined;
}
